import React from 'react';
import { Tag, Tooltip } from 'antd';
import styles from 'pages/admin/suppliers/styles.module.scss';
import { TagDotIcon } from 'components/common/icons';

interface ISupplierStatus {
  status: 'Active' | 'Invited' | 'Deactivated';
  tooltip?: string;
}

export const UserStatus = React.memo((props: ISupplierStatus) => {
  const { status, tooltip } = props;
  switch (status) {
    case 'Active':
      return (
        <Tag
          className={styles.supplier_tag}
          icon={<TagDotIcon color={'#1FC16B'} />}
          bordered={false}
          style={{ backgroundColor: '#E0FAEC', color: '#1FC16B' }}
        >
          Active
        </Tag>
      );
    case 'Invited':
      return (
        <Tooltip title={tooltip}>
          <Tag
            className={styles.supplier_tag}
            icon={<TagDotIcon color={'#FF8447'} />}
            bordered={false}
            style={{ backgroundColor: '#FFF1EB', color: '#FF8447' }}
          >
            Invited
          </Tag>
        </Tooltip>
      );
    case 'Deactivated':
      return (
        <Tooltip title={tooltip}>
          <Tag
            className={styles.supplier_tag}
            icon={<TagDotIcon color={'#FB3748'} />}
            bordered={false}
            style={{ backgroundColor: '#FFEBEC', color: '#FB3748' }}
          >
            Deactivated
          </Tag>
        </Tooltip>
      );
    default:
      return null;
  }
});
